module.exports = __webpack_public_path__ + "img/groups.bcd1a849.png";